import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import Timer from "../Timer"

import { logout, setMessage } from "../../store/actions"


export const useAuthenticate = (history, setAmountOfAttempts = (amount) => { }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
  const rememberDevice = localStorage.getItem("rememberDevice") === "true"
  const hasNotConfirmedContact = useSelector(state => state.auth.hasNotConfirmedContact)

  function pushToHistory() {
    if (user.authorities.indexOf("ROLE_ADMIN") !== -1) {
      if (location.pathname !== '/admin') {
        history.push("/admin")
      }
    } else if (!hasNotConfirmedContact) {
       history.push("/personal-account/profile")
    } else {
      history.push('/personal-account/verify-contacts')
    }
  }

  useEffect(() => {
    if (user) {
      setAmountOfAttempts(0)
      pushToHistory()

      if (location.pathname !== '/admin' && !rememberDevice) {
        const timer = new Timer({
          timeout: 1740, //1740 seconds == 29 minutes
          onTimeout: () => {
            dispatch(setMessage({ type: 'error', text: "Ваша сессия устарела." }))
            dispatch(logout()).then(() => {
              if (window.location.pathname.includes('personal-account') || window.location.pathname.includes('admin')) {
                history.push('/login')
              }
            })
            timer.cleanUp();
          }
        });
      }

    }
  }, [user, hasNotConfirmedContact, dispatch, history])
}
